// Ranq bar mark — the core graphic element from the brand system.
// Two stacked horizontal bars (shorter top, longer bottom) representing
// levels, position and progression.
export default function BarMark({
  className = "",
  size = 22,
  variant = "solid", // "solid" | "white" | "gradient"
  gap = 0.18, // ratio of size used as vertical gap
  stroke = 1.6, // bar height as fraction of half height
}) {
  const w = size * 1.6;
  const h = size;
  const barH = h * 0.22;
  const topW = w * 0.42;
  const botW = w * 0.78;
  const topY = h * 0.34 - barH / 2;
  const botY = h * 0.66 - barH / 2;

  const fillTop =
    variant === "white"
      ? "#ffffff"
      : variant === "gradient"
        ? "url(#ranq-bar-grad)"
        : "currentColor";
  const fillBot = fillTop;

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      className={className}
      aria-hidden="true"
    >
      {variant === "gradient" && (
        <defs>
          <linearGradient id="ranq-bar-grad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#ff5e3a" />
            <stop offset="100%" stopColor="#ffb59a" stopOpacity="0.4" />
          </linearGradient>
        </defs>
      )}
      <rect x={0} y={topY} width={topW} height={barH} fill={fillTop} />
      <rect x={0} y={botY} width={botW} height={barH} fill={fillBot} />
    </svg>
  );
}
